import React from 'react'

import { connect } from "react-redux"

import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { Card } from 'primereact/card'
import { Toolbar } from 'primereact/toolbar'

import * as appActionCreators from "../actionCreators/app"
import * as annualReturnActionCreators from "../actionCreators/annualReturn"
import * as systemParameterActionCreators from "../actionCreators/systemParameter"

import { downloadFile } from '../js/file'

import '../css/export-annual-return.css'

class ExportAnnualReturn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      annualReturnRange: { startYear: null, endYear: null }
    }
  }

  componentDidMount() {
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => this.props.getAnnualReturnPageText())
      .then(() => this.props.getAnnualReturnStartYear())
      .then(() => this.props.setLoading(false))
      .catch((error) => {
        this.props.handleError(error)
          .then(() => this.props.setLoading(false))
      })
  }

  exportAnnualReturnsToExcel = () => {
    let startDate = new Date(this.state.annualReturnRange.startYear, 0, 1, 0, 0, 0, 0)
    let endDate = new Date(this.state.annualReturnRange.endYear, 11, 31, 0, 0, 0, 0)
    let annualReturnRange = { startDate, endDate }
    this.exportToExcel(this.props.exportAnnualReturnsToExcel, annualReturnRange)
  }

  exportToExcel = (exportAction, data) => {
    // show loading icon since we are doing an ajax call
    this.props.setLoading(true)
      .then(() => exportAction(data))
      .then((response) => {
        var fileData = new Blob([response.data])

        // get filename from the content disposition header that is set server side
        let contentDisposition = response.headers['content-disposition']
        let filename = contentDisposition.substring(contentDisposition.indexOf('=') + 1)
        downloadFile(fileData, filename)

        this.props.setLoading(false)
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  getAnnualReturnYearOptions = () => {
    let currentYear = new Date().getFullYear()
    let availableYearOptions = []
    if (this.props.systemParameter.annualReturnStartYear) {
      for (let i = this.props.systemParameter.annualReturnStartYear; i <= currentYear; i++) {
        availableYearOptions.push({ label: i, value: i })
      }
    }

    return availableYearOptions
  }

  render() {
    let annualReturnOptions = this.getAnnualReturnYearOptions()

    return (
      <React.Fragment>
        <div className={"annual-return-page-text"} dangerouslySetInnerHTML={{ __html: this.props.systemParameter.annualReturnPageText }} />
        <Card title="Export Annual Returns" className="export-annual-return-card">
          <div className="p-grid export-annual-return-details">
            <div className="p-col-12">
              Please enter date range to export annual returns for
            </div>
            <div className="p-col-12 field-label-container">
              <label>Start Year </label>
            </div>
            <div className="p-col-12 field-element-container">
              <Dropdown value={this.state.annualReturnRange.startYear || ''}
                className={'app-dropdown'}
                options={annualReturnOptions}
                onChange={e => {
                  this.setState({ annualReturnRange: { ...this.state.annualReturnRange, startYear: e.value } })
                }}
              />
            </div>
            <div className="p-col-12 field-label-container">
              <label>End Year </label>
            </div>
            <div className="p-col-12 field-element-container">
              <Dropdown value={this.state.annualReturnRange.endYear || ''}
                className={'app-dropdown'}
                options={annualReturnOptions}
                onChange={e => {
                  this.setState({ annualReturnRange: { ...this.state.annualReturnRange, endYear: e.value } })
                }}
              />
            </div>
            {this.state.annualReturnRange && this.state.annualReturnRange.startYear && this.state.annualReturnRange.endYear && <Toolbar>
              <div className="p-toolbar-group-left">
                <Button className="export-annual-returns-btn" type="button" icon="pi pi-external-link" iconPos="left"
                  label="Export Annual Returns to Excel" onClick={() => this.exportAnnualReturnsToExcel()}></Button>
              </div>
            </Toolbar>}
          </div>
        </Card>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  let { auth, systemParameter } = state
  return { auth, systemParameter }
}

// this is how to combine actions available
const actionCreators = {
  ...appActionCreators,
  ...annualReturnActionCreators,
  ...systemParameterActionCreators
}

export default connect(mapStateToProps, actionCreators)(ExportAnnualReturn);


// WEBPACK FOOTER //
// ./src/container/ExportAnnualReturn.js